import Cookies from 'js-cookie';

const currenCookiesDL = ['guardarBorradorDL'];

/**
 * La funcion recorre las cookies configuradas en el archivo para en caso
 * de existir generar el datalayer correspondiente y luego eliminar la cookie.
 * EJ: Provenientes del publicador de profesionales - bumex
 */
export const execCookiesDL = () => {
  currenCookiesDL.forEach(cookie => {
    const dl = Cookies.get(cookie);
    if (!dl) return;
    try {
      // Remplazo + por espacios y decodifico
      const data = decodeURIComponent(dl.replaceAll('+', ' '));
      if (window.dataLayer) {
        window.dataLayer.push(JSON.parse(data));
        Cookies.remove(cookie);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  });
};

const PUBLISHER_TYPE_NAME = {
  PARTICULAR: 'Particular',
  PROFESIONAL: 'Profesional'
};

export const getPublisherTypeNameDL = id => {
  return id === '1' ? PUBLISHER_TYPE_NAME.PARTICULAR : PUBLISHER_TYPE_NAME.PROFESIONAL;
};

export const getPublisherScoreValue = score => {
  // valida que si el score no existe retorne NA para DLs segun docs de imetrics
  return score === null || score === undefined ? 'NA' : score;
};
